export type CollaborationState = {
  readOnlyByProjectId: Record<string, boolean>;
};

export const createInitialCollaborationState = (): CollaborationState => ({
  readOnlyByProjectId: {},
});
